export const ADD_FORMS = "ADDFORMS";
export const DELETE_FORMS = "DELETE_FORMS";
export const UPDATE_FORMS="UPDATE_FORMS"
export interface DataForms {}

interface FormsAction {
  type: typeof ADD_FORMS | typeof DELETE_FORMS | typeof UPDATE_FORMS;
  data: any;
}

export type FormsActionType = FormsAction;
